import React, { useState, useEffect, useContext } from "react";
import { Col, Divider, Row, Skeleton, Space, Typography } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import InfiniteScroll from "react-infinite-scroll-component";
import { UserInfoContext } from "../../../../../Context/CommonContext";
import { IUserInfo } from "../../../../../utilFunctions/CommonInterfaces/userInterface";
import { useComments } from "./useComments";
import { CommentPost } from "Pages/MyBatches/Channels/ChannelComponents/ChannelComments/CommentPost";
import { CommentInput } from "Pages/MyBatches/Channels/ChannelComponents/ChannelComments/CommentInput";

export type UserRole = "Faculty" | "Student" | "STUDENT";

export interface CommentUser {
  id: string | number | null;
  name: string;
  imageUrl?: string;
  role: UserRole;
}

export interface Comment {
  id: number;
  author: CommentUser;
  timestamp: string;
  content: string;
  isOwnPost: boolean;
  replyCount: number;
  replies?: Comment[];
  parentCommentId: number | null;
}

export function ChannelCommentHome({
  selectedPost,
  refreshTrigger,
  // allPosts,
  handleIncrementCommentCount,
  handleDecrementCommentCount,
  onCommentsFetched,
}: any) {
  const user = useContext<IUserInfo>(UserInfoContext);
  const [activeReplyId, setActiveReplyId] = useState<number | null>(null);
  const [activeEditId, setActiveEditId] = useState<number | null>(null);
  const [selectedBatch, setSelectedbatch] = useState<any>(null);
  console.log("selectedPost in comments", selectedBatch, selectedPost);
  useEffect(() => {
    if (selectedPost?.postBatchId) {
      console.log("selectedPost in comments", selectedBatch, selectedPost);
      setSelectedbatch(selectedPost?.postBatchId);
    }
  }, [selectedPost?.postBatchId]);

  const {
    comments,
    setComments,
    loading,
    loadingRepliesFor,
    hasMore,
    next,
    fetchReplies,
    createComment,
    updateComment,
    deleteComment,
    isSubmitting,
  } = useComments(
    selectedBatch,
    user,
    refreshTrigger,
    (response, payload) => {
      const formattedComment: Comment = {
        id: response.data,
        author: {
          id: user.id,
          name: user.user_name || "You",
          role: user.fexRole as UserRole,
          imageUrl: user.imageUrl || "",
        },
        timestamp: new Date().toISOString(),
        content: payload.text,
        isOwnPost: true,
        replies: [],
        replyCount: 0,
        parentCommentId: payload.parentCommentId,
      };

      if (formattedComment.parentCommentId) {
        setComments((prevComments) =>
          prevComments.map((parent) => {
            if (parent.id === formattedComment.parentCommentId) {
              return {
                ...parent,
                replies: [...(parent.replies || []), formattedComment],
                replyCount: (parent.replyCount || 0) + 1,
              };
            }
            return parent;
          })
        );
      } else {
        setComments((prevComments) => [formattedComment, ...prevComments]);
        if (handleIncrementCommentCount) {
          handleIncrementCommentCount(selectedPost.id);
        }
      }
    },
    onCommentsFetched
  );

  const handlePostComment = (
    text: string,
    parentCommentId: number | null = null
  ) => {
    if (user.id) {
      createComment(text, selectedBatch, user.id, parentCommentId ?? null);
    }
  };

  const handleEditComment = (text: string, commentId: number | null) => {
    if (commentId !== null && user.id) {
      updateComment(text, commentId, user.id);
    }
  };

  const handleDeleteComment = (
    commentId: number,
    parentCommentId: number | null
  ) => {
    deleteComment(commentId);
    setComments((prevComments) => {
      if (parentCommentId === null) {
        if (handleDecrementCommentCount) {
          handleDecrementCommentCount(selectedPost.id);
        }
        return prevComments.filter((comment) => comment.id !== commentId);
      } else {
        return prevComments.map((parentComment) => {
          if (parentComment.id === parentCommentId && parentComment.replies) {
            return {
              ...parentComment,
              replies: parentComment.replies.filter(
                (reply) => reply.id !== commentId
              ),
              replyCount: (parentComment.replyCount || 0) - 1,
            };
          }
          return parentComment;
        });
      }
    });
  };
  console.log("comments", comments);
  return (
    <div style={{ marginTop: "24px" }}>
      <Row style={{ marginBottom: "20px" }}>
        <Col span={24}>
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              color: "#1a1a1a",
              fontWeight: 600,
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <MessageOutlined style={{ fontSize: "18px", color: "#8c8c8c" }} />
            Comments
          </Typography.Title>
        </Col>
      </Row>
      {loading && comments.length === 0 ? (
        <Skeleton avatar paragraph={{ rows: 3 }} active />
      ) : (
        comments.length > 0 && (
          <>
            <InfiniteScroll
              dataLength={comments.length}
              next={next}
              hasMore={hasMore}
              loader={
                loading && <Skeleton avatar paragraph={{ rows: 1 }} active />
              }
              style={{ paddingBottom: "8px" }}
            >
              <Space
                direction="vertical"
                size="large"
                style={{ width: "100%" }}
              >
                {comments.map((comment) => (
                  <CommentPost
                    key={comment.id}
                    comment={comment}
                    onReply={handlePostComment}
                    onEdit={handleEditComment}
                    onDelete={handleDeleteComment}
                    activeReplyId={activeReplyId}
                    activeEditId={activeEditId}
                    setActiveReplyId={setActiveReplyId}
                    setActiveEditId={setActiveEditId}
                    user={user}
                    fetchReplies={fetchReplies}
                    loadingRepliesFor={loadingRepliesFor}
                  />
                ))}
              </Space>
            </InfiniteScroll>
            <Divider />
          </>
        )
      )}

      {!loading && (
        <CommentInput
          onSubmit={(text) => handlePostComment(text, null)}
          isSubmitting={isSubmitting}
          user={user}
        />
      )}
    </div>
  );
}
